import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';

import { CHANNEL, getChannelPerformanceLabel } from 'src/data/channel';
import {
  CONNECT_TO_CHANNEL_ORIGIN,
  EMAIL_CSV_RESOURCE_DOCUMENTS,
  getResourceDocumentLabel,
} from 'src/data/performance';
import { useAddResourcePopup } from 'src/services/popup';
import ChannelIcon from 'src/components/ChannelIcon';
import { useStyles } from './useStyles';

export const ConnectToEmailPopup = ({ open, onClose, onIntegrationClick }) => {
  const styles = useStyles();

  const openAddResourcePopup = useAddResourcePopup();

  return (
    <Dialog
      open={open}
      classes={{ paper: styles.root }}
      onClose={onClose}
      maxWidth="md"
      data-testid="ConnectToEmailPopup"
    >
      <DialogTitle className={styles.dialogTitle}>
        <Typography className={styles.popupTitle}>Select Source</Typography>
      </DialogTitle>

      <DialogContent className={styles.dialogContent}>
        <Button
          className={styles.channelButton}
          classes={{ label: styles.buttonLabel }}
          onClick={() => {
            onIntegrationClick(CHANNEL.hubspot, CONNECT_TO_CHANNEL_ORIGIN.benchmark);
            onClose();
          }}
        >
          <ChannelIcon
            className={styles.channelIcon}
            channel={CHANNEL.hubspot}
          />
          {getChannelPerformanceLabel(CHANNEL.hubspot)}
        </Button>

        {EMAIL_CSV_RESOURCE_DOCUMENTS.map((csvResource) => (
          <Button
            className={styles.channelButton}
            classes={{ label: styles.buttonLabel }}
            onClick={() => {
              openAddResourcePopup(csvResource);
              onClose();
            }}
          >
            <ChannelIcon
              className={styles.channelIcon}
              channel={csvResource}
            />
            {getResourceDocumentLabel(csvResource)} (CSV)
          </Button>
        ))}
      </DialogContent>
      <DialogActions className={styles.dialogActions}>
        <Button
          className={styles.buttonClose}
          onClick={onClose}
          variant="text"
          color="primary"
          aria-label="Close"
          data-testid="ConnectToEmailPopup__CloseButton"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConnectToEmailPopup.propTypes = {
  className: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onIntegrationClick: PropTypes.func.isRequired,
};
ConnectToEmailPopup.defaultProps = {
  className: null,
  open: false,
};
